import { render } from "./ModalPermisosVistas.vue?vue&type=template&id=1b56113c&scoped=true"
import script from "./ModalPermisosVistas.vue?vue&type=script&lang=js"
export * from "./ModalPermisosVistas.vue?vue&type=script&lang=js"

import "./ModalPermisosVistas.vue?vue&type=style&index=0&id=1b56113c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b56113c"]])

export default __exports__